import React from 'react'

export default function AttentionLarge(props) {
  return (
    <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M32 0C14.336 0 0 14.336 0 32C0 49.664 14.336 64 32 64C49.664 64 64 49.664 64 32C64 14.336 49.664 0 32 0ZM28.8 48V41.6H35.2V48H28.8ZM28.8 16V35.2H35.2V16H28.8Z'
        fill='#EB5757'
      />
    </svg>
  )
}
